{
  "de": {
    "decision": {
      "actions": {
        "add": "Hinzufügen",
        "addDocument": "Dokument hinzufügen",
        "addUnits": "Einheiten",
        "approve": "Genehmigen",
        "autoCloseAfterApproval": "Automatisch schließen nach Genehmigung",
        "autoCloseAfterApprovalInfo": "Die Entscheidung wird geschlossen, sobald ein Angebot genehmigt wird",
        "autoCloseAfterDeadline": "Automatisch schließen nach Fristablauf",
        "cancel": "Rückgängig machen",
        "changeResponsible": "Verantwortlichen ändern",
        "clickToSetDeadline": "Klicken, um Frist festzulegen",
        "closeDecision": "Entscheidung schließen",
        "confirmChoices": "Optionen bestätigen",
        "createProposal": "Angebot erstellen",
        "create_decisions": "Entscheidung erstellen | Entscheidungen erstellen",
        "delete": "Löschen",
        "deleteCount": "Sie sind dabei, {count} Entscheidung zu löschen. Sind Sie sicher? | Sie sind dabei, {count} Entscheidungen zu löschen. Sind Sie sicher?",
        "deleteMultipleDecisions": "Löschen …",
        "delete_cancel": "Abbrechen",
        "delete_decisions": "Entscheidung löschen | Entscheidungen löschen",
        "edit": "Bearbeiten",
        "editBudget": "Budget bearbeiten",
        "editDeadline": "Frist bearbeiten",
        "editDecision": "Entscheidung bearbeiten",
        "editReminders": "Erinnerungen bearbeiten",
        "goToDecision": "Zur Entscheidung gehen",
        "goToProposal": "Zum Angebot gehen",
        "goToSummary": "Zur Zusammenfassung gehen",
        "hide": "Veröffentlichung aufheben",
        "hideInfo": "Infos ausblenden",
        "noDescription": "Klicken, um eine Beschreibung hinzuzufügen",
        "openDecision": "Entscheidung öffnen",
        "publish": "Veröffentlichen",
        "publishAll": "Für alle",
        "publishCustomer": "Für Kunden veröffentlichen",
        "publishPartners": "Für Partner veröffentlichen",
        "reject": "Ablehnen",
        "relaunch_decision": "Entscheidung neu starten",
        "request_changes": "Änderungen anfordern",
        "reset": "Zurücksetzen",
        "save": "Speichern",
        "save_and_share_partners": "Speichern und mit Partnern teilen",
        "selectAll": "Alle {total} Einheiten auswählen",
        "selectChoices": "Optionen auswählen",
        "share_proposals": "Angebote teilen",
        "showMoreInfo": "Weitere Infos anzeigen",
        "stopApproving": "Genehmigung beenden",
        "submit": "Absenden",
        "tickBoxesDeletion": "Aktivieren Sie die Kontrollkästchen der Dateien, die Sie löschen möchten.",
        "unSelectAll": "Auswahl aufheben.",
        "unpublishForCustomer": "Veröffentlichung für Kunden aufheben",
        "unpublishForPartners": "Veröffentlichung für Entscheidungspartner aufheben",
        "update": "Aktualisieren",
        "upload": "Hochladen",
        "upload_documents": "Dokumente hochladen",
        "upload_proposals": "Angebot erstellen"
      },
      "attributes": {
        "amount_gross": "Bruttoangebot",
        "amount_net": "Nettoangebot",
        "approved_at": "Genehmigungsdatum des Angebots",
        "approved_proposal_name": "Genehmigtes Angebot",
        "bathrooms": "Anzahl Badezimmer",
        "bedrooms": "Anzahl Schlafzimmer",
        "category": "Kategorie",
        "customer_group_name": "Kunde",
        "decision_name": "Entscheidung",
        "decisions_count": "{count} Entscheidung | {count} Entscheidungen",
        "due_date": "Frist",
        "floor": "Etage",
        "negative_surcharges_allowed": "Gutschrift zulassen",
        "note_employee": "Notiz",
        "price_budget": "Budget",
        "price_budget_extra": "Zusatzbudget",
        "price_budget_info": "Sie können das Budget jederzeit später bearbeiten",
        "price_budget_info_mup": "Sie können das Budget pro Einheit jederzeit später bearbeiten",
        "price_margin": "Marge",
        "price_surcharge": "Mehrpreis",
        "published": "Veröffentlicht",
        "responsible": "Verantwortlich",
        "status": "Status",
        "unit": "Einheit",
        "verification_type": "Genehmigungsentscheidung getroffen von",
        "visibility": "Sichtbarkeit"
      },
      "edit_actions": {
        "edit_auto_close": "Einstellungen für automatisches Schließen",
        "edit_close_decision": "Entscheidung schließen/öffnen",
        "edit_deadline": "Frist festlegen",
        "edit_margin": "Margen festlegen",
        "edit_negative_surcharges_allowed": "Gutschrift zulassen",
        "edit_not_interested_allowed": "Option „Kein Interesse“ zulassen",
        "edit_note_employee": "Notiz bearbeiten",
        "edit_price_budget": "Budget festlegen",
        "edit_price_budget_extra": "Zusatzbudget festlegen",
        "edit_reminders": "Erinnerungen festlegen",
        "edit_responsible": "Verantwortlichen festlegen"
      },
      "labels": {
        "accessRights": "Zugriffsrechte",
        "activity": "Aktivität",
        "addDecisionNote": "Notiz hinzufügen",
        "addReminders": "Erinnerungen hinzufügen",
        "allUnits": "Alle Einheiten",
        "allow_not_interested": "Option „Kein Interesse“ zulassen",
        "allow_not_interested_cancel_warning": "Diese Entscheidung ist derzeit als „Kein Interesse“ markiert. Wenn Sie diese Option deaktivieren, wird der Status „Kein Interesse“ aufgehoben.",
        "allow_not_interested_info": "Zeigt eine Option „Kein Interesse“ neben den Angeboten an",
        "approved": "Genehmigt",
        "approvedAt": "Genehmigt am {approved_at}",
        "approvedProposal": "Genehmigtes Angebot",
        "askQuestion": "Stellen Sie hier Ihre Fragen zu Ihrer Entscheidung {decision}",
        "assignCustomerToUnit": "Kunden zuweisen",
        "autoClose": "Automatisch schließen",
        "budgetOverview": "Budgetübersicht",
        "budgetSubtitle": "Geben Sie hier ein Budget ein, wenn es für alle ausgewählten Einheiten gilt, oder fügen Sie Budgets später hinzu",
        "budgetTitle": "Ein Budget festlegen",
        "checkbox": "Kontrollkästchen",
        "clickHereToChange": "Klicken Sie hier, wenn Sie diese ändern möchten.",
        "close": "Schließen",
        "closeDecision": "Entscheidung schließen",
        "closed": "Die Entscheidung ist für diese Einheit geschlossen. Der Kunde kann kein Angebot mehr genehmigen.",
        "closedLabel": "Geschlossen",
        "closed_tag": "Entscheidung geschlossen",
        "closed_tooltip_customer": "Die Entscheidung ist geschlossen. Sie können kein Angebot mehr genehmigen.",
        "countDocuments": "Noch keine Dokumente | 1 Dokument | {count} Dokumente",
        "countEdit": "Die Entscheidung von {count} Einheit bearbeiten | Die Entscheidung von {count} Einheiten bearbeiten",
        "countUpload": "Dokument(e) zu dieser Einheit hochladen | Dokument(e) zu {count} Einheiten hochladen",
        "created_on": "Entscheidung erstellt am {date}",
        "custom_columns_title": "Sie können bis zu 10 Spalten hinzufügen",
        "customer": "Kunde",
        "customer_status": "Kundenstatus",
        "decided": "Entschieden",
        "decision": "Entscheidung",
        "decisionBreadcrumb": "Entscheidung {decision_type}",
        "decisionNotPublishedYetFor": "Entscheidung noch nicht veröffentlicht für",
        "decisionNoteExplainer": "Diese Notiz ist nur für Ihr Team und für die Partner sichtbar, die diese Entscheidung sehen dürfen",
        "decisionType": "Entscheidungsthema",
        "decisionUnit": "Entscheidung für Einheit {unit}",
        "decisions": "Entscheidungen",
        "decisions_all_projects": "Entscheidungen aller Projekte",
        "decisions_breadcrumb": "Entscheidungen {project}",
        "default": "Standard",
        "deleteExplanation": "Alle Kommunikationsnachrichten, Dateien, Angebote und weiteren Daten werden dauerhaft von der Plattform entfernt. Kunden und Partner, die mit diesen Entscheidungen verknüpft sind, verlieren jeglichen Zugriff.",
        "descriptionSubtitle": "Hier können Sie weitere Informationen für Ihre Kunden hinzufügen",
        "descriptionTitle": "Fügen Sie eine Beschreibung für Ihren Kunden hinzu",
        "documentRequired": "Unterschriebenes Dokument für die Genehmigung erforderlich",
        "documentUnits": "Einheitenordner",
        "documents": "Dokumente",
        "dueDate": "Fällig am {date}",
        "due_date_subtitle": "Legen Sie ein Datum fest, bis zu dem die Entscheidung getroffen werden muss",
        "due_date_title": "Frist und Erinnerungen",
        "editDecisionNote": "Notiz bearbeiten",
        "extra_options": "Weitere Einstellungen",
        "false": "Nein",
        "filter": "Filter",
        "finalSettings": "Einige optionale Einstellungen",
        "finalSettingsStep": "Letzte Einstellungen",
        "financial": "Finanzen",
        "firstThingsfirst": "Zunächst ein paar allgemeine Informationen",
        "follow": "Folgen",
        "following": "Gefolgt – Sie erhalten Benachrichtigungen",
        "four": "4",
        "giveNewAmount": "Neuen Betrag eingeben",
        "hideCount": "Veröffentlichung dieser Entscheidung für 1 Einheit aufheben | Veröffentlichung der Entscheidung für {count} Einheiten aufheben",
        "hideVisibilitySettings": "Sichtbarkeitseinstellungen ausblenden",
        "indicate_not_interested": "Angeben, dass der Kunde an dieser Entscheidung kein Interesse hat",
        "info": "Weitere Infos anzeigen",
        "infoCustomers": "Kundendetails",
        "information": "Informationen",
        "leaveBudgetEmptyInfo": "Leer lassen, wenn Sie keine Mehrpreise und keine Gutschrift verwenden möchten",
        "make_a_decision": "Eine Entscheidung treffen",
        "marginOnBudget": "Marge auf Budget (%)",
        "marginOnUpgrades": "Marge auf Mehrpreise (%)",
        "marginOnUpgradesExplainer": "Die Marge auf Mehrpreise wird auch auf die Zusatzbudgets angewendet, die Sie einem Kunden gewähren. Das Zusatzbudget kann innerhalb der Entscheidung einer Einheit festgelegt werden.",
        "marginOverview": "Margenübersicht",
        "marginSubTitle": "Margen automatisch als Prozentsätze berechnen",
        "marginTitle": "Margen in Prozent verwenden",
        "members": "Mitglieder",
        "modifyLater": "Sie können diese Einstellungen später ändern",
        "name": "Name",
        "newActivity": "Neue Aktivität",
        "newDocument": "Neue(s) Dokument(e)",
        "next": "Weiter",
        "no": "Nein",
        "noApprovedProposalYet": "Noch kein Angebot angenommen",
        "noBudget": "Kein Budget festgelegt",
        "noCustomer": "Noch kein Kunde",
        "noCustomerAssigned": "Der Einheit ist noch kein Kunde zugewiesen",
        "noDeadline": "Keine Frist",
        "noDecisionDueDate": "Frist auswählen",
        "noDecisionStartDate": "Kein Startdatum festgelegt",
        "noDecisionsMade": "Noch keine Entscheidungen getroffen",
        "noDecisionsToMake": "Keine Entscheidungen zu treffen.",
        "noDecisionsYet": "Noch keine Entscheidungen",
        "noDocumentsShared": "Keine Dokumente geteilt",
        "noDueDate": "Legen Sie zuerst eine Frist fest, bevor Sie Erinnerungen einrichten",
        "noDueDateSet": "Keine Frist festgelegt",
        "noExtraBudget": "Kein Zusatzbudget",
        "noMessages": "Schreiben Sie Ihre erste Nachricht für {decision} in das Feld unten",
        "noUnitDocuments": "Dem Einheitenordner wurden noch keine Dokumente hinzugefügt",
        "noUnitsClick": "Noch keine Einheiten, hier klicken zum Hinzufügen",
        "no_result_for_search": "Kein Ergebnis für diese gefilterte Suche.",
        "no_surcharges": "Keine Mehrpreise",
        "no_surcharges_info": "Angebote ohne Mehrpreise",
        "notDecided": "Noch nicht entschieden",
        "notDecidedYet": "Der Kunde hat noch keine Entscheidung getroffen.",
        "notFollowing": "Nicht gefolgt – klicken, um Benachrichtigungen zu erhalten",
        "notPossibleToWriteMessageDeactivatedUnit": "Diese Entscheidung bezieht sich auf eine deaktivierte Einheit. Das Schreiben einer neuen Nachricht ist nicht mehr möglich.",
        "notPublished": "Nicht veröffentlicht",
        "notPublishedCustomer": "Entscheidung noch nicht für Kunden veröffentlicht",
        "notPublishedPartners": "Entscheidung noch nicht für Entscheidungspartner veröffentlicht",
        "notShared": "Nicht geteilt",
        "not_interested": "Kein Interesse",
        "not_interested_customer": "Kein Interesse",
        "not_interested_customer_info": "Wenn Sie an dieser Entscheidung kein Interesse haben oder diese Entscheidung für Sie nicht relevant ist, klicken Sie bitte hier, um dies anzugeben.",
        "not_interested_modal": {
          "customer": {
            "body": "Teilen Sie uns kurz mit, warum Sie an dieser Entscheidung kein Interesse haben.",
            "title": "Ich habe kein Interesse an dieser Entscheidung"
          },
          "employee": {
            "body": "Teilen Sie mit, warum der Kunde an dieser Entscheidung kein Interesse hat. Dieses Feedback ist auch für den Kunden sichtbar.",
            "title": "Der Kunde hat kein Interesse an dieser Entscheidung"
          },
          "feedback": "Feedback"
        },
        "one": "1",
        "open": "Öffnen",
        "openDecisionInfo": "Diese Entscheidung ist offen. Der Kunde kann Angebote genehmigen.",
        "open_auto_close_deadline_unit": "Legen Sie fest, ob die Entscheidung bei Ablauf der Frist automatisch geschlossen wird",
        "open_auto_close_unit": "Legen Sie fest, ob die Entscheidung bei Genehmigung automatisch geschlossen wird",
        "open_close_unit": "die Entscheidung für 1 Einheit | die Entscheidung für {unit_count} Einheiten",
        "or": "oder",
        "participants": "Teilnehmer",
        "partners": "Entscheidungspartner",
        "pendingDecisions": "1 zu treffende Entscheidung | {count} zu treffende Entscheidungen",
        "priceBudget": "Budget",
        "priceBudgetExtra": "Zusatzbudget",
        "proposal": "Angebote",
        "proposals": "Angebote | 1 Angebot | {count} Angebote",
        "publish?": "Speichern und veröffentlichen?",
        "publishNow?": "Jetzt veröffentlichen?",
        "publishTopOfPage": "Sie können diese Entscheidung oben auf dieser Seite veröffentlichen",
        "publishedCount": "Diese Entscheidung für 1 Einheit veröffentlichen | Entscheidung für {count} Einheiten veröffentlichen",
        "publishedCustomer": "Entscheidung für Kunden veröffentlicht",
        "publishedCustomerPartners": "Entscheidung für Kunden und Entscheidungspartner veröffentlicht",
        "publishedNone": "Noch nicht veröffentlicht",
        "publishedPartners": "Entscheidung für Entscheidungspartner veröffentlicht",
        "publishedSince": "Entscheidung veröffentlicht seit {date}",
        "published_info": "Zeigt an, ob alle Einheiten für Kunden und/oder Entscheidungspartner veröffentlicht wurden",
        "remainOpen": "Offen bleiben",
        "reminders": "Erinnerungen",
        "remindersCount": "1 Erinnerung | {count} Erinnerungen",
        "reopenDecision": "Entscheidung wieder öffnen",
        "requiresDocumentVerification": "Erfordert unterschriebenes Dokument zur Genehmigung",
        "requiresNoDocumentVerification": "Kein unterschriebenes Dokument für die Genehmigung erforderlich",
        "returnToTickets": "Zurück",
        "rights": {
          "access_full": "Voller Zugriff",
          "access_full_info": "Kann Nachrichten, Dokumente und Angebote direkt mit dem Kunden teilen",
          "access_full_short": "Voll",
          "access_none": "Eingeschränkter Zugriff",
          "access_none_info": "Keine Kommunikation mit dem Kunden: nur für internen Gebrauch",
          "access_none_short": "Eingeschränkt",
          "access_semi": "Basiszugriff",
          "access_semi_info": "Kann Nachrichten an den Kunden senden, aber keine Dokumente oder Angebote",
          "access_semi_short": "Basis",
          "customer_show": "Kann die Kundeninformationen einsehen.",
          "default": "Entscheidungspartner können jederzeit Nachrichten senden, Dokumente hochladen und Angebote für <b>{client_name}</b> erstellen. Sie haben außerdem Zugriff auf die Pläne im Dokumentenordner der Einheit. Unten können Sie ihre Kommunikationsrechte gegenüber Ihren Kunden bearbeiten.",
          "document_customer": "Kann ihre Dokumente direkt mit dem Kunden teilen.",
          "message_customer": "Kann Nachrichten an den Kunden senden.",
          "proposal_customer": "Kann ihre Angebote direkt mit dem Kunden teilen."
        },
        "save?": "Speichern?",
        "saveExplainer": "Diese Entscheidung für Ihre Kunden sichtbar machen? Oder später speichern und veröffentlichen?",
        "select": "Auswählen",
        "selectOneUnit": "Mindestens 1 Einheit auswählen",
        "selectUnits": "Einheiten auswählen",
        "select_units": "Einheiten auswählen",
        "selected": "{selected} Einheit ausgewählt. | {selected} Einheiten ausgewählt.",
        "sharedWith": "Geteilt mit",
        "showDecisionsFor": "Entscheidungen anzeigen für",
        "show_all_units": "Alle Einheiten anzeigen",
        "signOnline": "Namen zur Bestätigung eingeben (Standard)",
        "signUploadDocument": "Unterschriebenes Dokument hochladen",
        "signedDocument": "Unterschriebenes Dokument hochladen",
        "status": "Status",
        "statusExplained": "Was bedeutet jeder Entscheidungsstatus?",
        "step2Subtitle": "Wählen Sie Ihr Projekt aus, um alle Ihre Einheiten auf einmal einzubeziehen.",
        "step2Title": "Welche Einheiten müssen eine Entscheidung treffen?",
        "step2TitleWithDecisionName": "Welche Einheiten müssen eine Entscheidung für {decision_name} treffen?",
        "subject": "Betreff",
        "summary": "Zusammenfassung",
        "surcharge_tooltip": "Dies ist der Mehrpreis für diese Entscheidung",
        "surcharges_total": "Mehrpreise: {total}",
        "surcharges_total_tooltip": "Dies ist der Gesamtbetrag der Mehrpreise für alle Einheiten mit einem Mehrpreis",
        "three": "3",
        "tickets": "Konversationen",
        "toBeDecided": "Noch zu entscheiden",
        "toDecide": "Zu entscheiden",
        "total": "Gesamt",
        "totalSelected": "Alle {total} Einheiten sind ausgewählt.",
        "true": "Ja",
        "two": "2",
        "type": "Typ",
        "unitDecisionsWillBeShownHere": "Einheitenentscheidungen werden hier angezeigt",
        "unitNotActivated": "Nur für aktivierte Einheiten",
        "unitSelected": "Keine Einheit | Eine Einheit | {count} Einheiten",
        "unit_name": "Einheit",
        "units": "Einheiten",
        "unpublish": "Nicht veröffentlicht",
        "unpublished": "Unveröffentlicht",
        "uploadDocument": "Dokumente hochladen",
        "useMargins": "Margen in Prozent aktivieren",
        "use_surcharges": "Mehrpreise verwenden",
        "use_surcharges_info": "Ein Budget für Mehrpreise festlegen",
        "validation_errors": "Es gibt Probleme mit diesem Angebot. Beheben Sie diese zuerst und versuchen Sie es dann erneut.",
        "waitingForClient": "Warten auf den Auftraggeber",
        "whatTheCustomerHasBought": "Was der Kunde gekauft hat",
        "when": "Wann",
        "who": "Wer",
        "withAll": "Alle",
        "withClient": "Nur mit {client}",
        "withCustomer": "Mit Kunde",
        "withCustomerName": "Mit {customer}",
        "withPartners": "Nur mit Entscheidungspartnern",
        "yes": "Ja"
      },
      "legend": {
        "all": "Alle Entscheidungen",
        "approved": "Entschieden",
        "approvedAfterDue": "Angebot nach Ablauf der Frist genehmigt",
        "created": "Noch kein Angebot",
        "decisionApproved": "Entschieden",
        "hasDecision": "Noch kein Angebot",
        "hasProposal": "Angebot hochgeladen",
        "has_proposal": "Noch zu entscheiden",
        "isExpired": "Frist abgelaufen, kein Angebot hochgeladen",
        "isExpiredHasProposal": "Frist abgelaufen, Angebot hochgeladen",
        "noDecision": "Einheit von dieser Entscheidung ausgeschlossen",
        "not_interested": "Kein Interesse",
        "other_decisions": "Andere Entscheidungen",
        "requested_changes": "Änderungen angefordert",
        "waiting_for_proposal": "Warten auf Angebot"
      },
      "navigation": {
        "backToDecisions": "Zurück zu den Entscheidungen"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Neue Entscheidungen folgen in Kürze!",
            "title": "Machen Sie sich bereit, eine Entscheidung zu treffen"
          },
          "no_documents": {
            "subtitle": "Hier finden Sie alle Dokumente zu dieser Entscheidung",
            "title": "Dokumente zur Entscheidung {decision_name} hochladen"
          }
        },
        "employees": {
          "conversations": {
            "none": {
              "subtitle": "Sobald der Einheit ein Kunde zugewiesen ist, sehen Sie hier die Konversationen",
              "title": "Hier finden Sie alle Konversationen zu dieser Entscheidung"
            }
          },
          "new": {
            "subtitle": "Weisen Sie eine Entscheidung mehreren Einheiten auf einmal zu",
            "title": "Erstellen Sie Ihre erste Entscheidung"
          }
        },
        "partners": {
          "none": {
            "subtitle": "Sie erhalten eine E-Mail-Benachrichtigung, sobald eine neue Entscheidung veröffentlicht wird.",
            "title": "Sie haben noch keine Entscheidungen"
          }
        }
      },
      "toasts": {
        "bulk_create": "Entscheidung wurde erfolgreich erstellt | Entscheidungen wurden erfolgreich erstellt",
        "bulk_delete": "Entscheidung wurde erfolgreich gelöscht | Entscheidungen wurden erfolgreich gelöscht",
        "bulk_update": "Entscheidung wurde erfolgreich aktualisiert | Entscheidungen wurden erfolgreich aktualisiert",
        "update": "Entscheidung wurde erfolgreich aktualisiert"
      },
      "validation": {
        "amountRequired": "Betrag ist erforderlich",
        "cannotUpdatePrice": "Das Budget kann nicht bearbeitet werden, da auf dieser Entscheidung basierende Raten für den Kunden sichtbar gemacht wurden",
        "customer": {
          "need_not_interested_note": "Geben Sie Feedback dazu, warum Sie an dieser Entscheidung kein Interesse haben"
        },
        "employee": {
          "need_not_interested_note": "Geben Sie Feedback dazu, warum der Kunde an dieser Entscheidung kein Interesse hat."
        },
        "installmentsSent": "Für einige der ausgewählten Entscheidungen sind Raten für den Kunden sichtbar. Deren Budget bleibt unverändert.",
        "mustBeZeroOrMore": "Muss 0 oder mehr sein",
        "needAttachment": "Laden Sie mindestens ein neues Dokument hoch oder wählen Sie eines aus dem Einheitenordner aus",
        "needNumber": "Zahl erforderlich (z. B. 8400,5)",
        "needTitle": "Titel ist erforderlich",
        "need_responsible": "Verantwortlicher erforderlich",
        "priceBudgetNotNegative": "Das Budget darf keine negative Zahl sein.",
        "responsibleRequired": "Verantwortlicher erforderlich",
        "selectContactPerson": "Mindestens 1 Ansprechpartner auswählen"
      }
    }
  }
}
